import React from "react";
import { Box, Grid } from "@material-ui/core";

import { Section, ProjectCard } from "../components";

import "../styles/index.scss";

import { en } from "../content";

function Projects({ setProjectOnDisplay }) {
  const content = en.projects;
  return (
    <Box py={12} className="projects">
      <Section>
        <Grid container spacing={2}>
          {content.projects.map((project) => (
            <Grid item xs={12} sm={6} md={4} key={project.name}>
              <ProjectCard
                project={project}
                setProjectOnDisplay={setProjectOnDisplay}
              />
            </Grid>
          ))}
        </Grid>
      </Section>
    </Box>
  );
}

export default Projects;
